import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
  // The text line, not its padded container, is what's cut and what the
  // tooltip is anchored to, so it opens over the text and only while hovering it.
  text: {
    display: "block",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  tooltip: {
    fontSize: 12,
    overflowWrap: "anywhere",
  },
}));
